export namespace ReadyUtils {
    export function removeBodyNoScroll() {
        document.body.classList.remove('lb_noScroll');
    }
    export function addBodyNoScroll() {
        document.body.classList.add('lb_noScroll');
    }
}